/** @file Thai catalog part of area E8 (W3-03), partial; replaced whole by that area. */

/** The `live`, `activity` and `aiView` blocks (spread at the top level); partial, English fills the gaps. S0 composes it into `th`. */
export const liveTh = {
  live: {
    pills: 'ใครอยู่ที่นี่', offline: 'ออฟไลน์ กำลังเชื่อมต่อใหม่…', connecting: 'กำลังเชื่อมต่อ…', live: 'ออนไลน์',
    catchingUp: 'กำลังตามการแก้ไข…', resyncing: 'กำลังโหลดเอกสารใหม่…',
    online: '{actor}', editing: '{actor}: {name}', recent: '{actor}: เพิ่งแก้ไข',
  },
  activity: {
    title: 'กิจกรรม', empty: 'ยังไม่มีการแก้ไข', rev: 'r{rev}', revert: 'ย้อนกลับ', reverting: 'กำลังย้อนกลับ…',
    reverted: 'ย้อนกลับแล้ว', repair: 'ซ่อมแซม', revertOf: 'ย้อนกลับ r{rev}', sending: '{names}: กำลังส่ง…', retry: 'ลองอีกครั้ง', dismiss: 'ปิด',
    loadOlder: 'โหลดเก่ากว่านี้', commandTimes: '{name} ×{n}', moreTargets: '+{n}', openAiView: 'ดูภาพที่ {actor} เรนเดอร์',
  },
  aiView: {
    title: 'มุมมอง AI', actors: 'ผู้ใช้งาน', allActors: 'ทั้งหมด', empty: 'ยังไม่มีภาพ ภาพที่เรนเดอร์ผ่าน MCP หรือ REST จะแสดงที่นี่ 24 ชั่วโมง',
    loadOlder: 'โหลดเก่ากว่านี้', open: 'เปิดขนาดเต็ม', close: 'ปิด', expired: 'ลิงก์นี้หมดอายุแล้ว', setup: 'ท่าเริ่มต้น',
    contactSheet: 'contact sheet', spriteSheet: 'sprite sheet', gif: 'GIF', frame: 'เฟรม {n}', time: '{s} วินาที',
    compare: 'r{a} เทียบ r{b}', autorig: 'ตรวจ autoRig', meta: 'r{rev} · {w}×{h}',
  },
} as const;
